import React from 'react';
import './exercise-practice.css';

/** Shared sizing for every exercise kind, including template practice previews. */
export default function ExercisePracticeLayout({ children }: { children: React.ReactNode }) {
  return <div className="exercise-practice">{children}</div>;
}
